export default {
  SET_LOADING_STATUS: '@YOLA_EDITOR/SUBSCRIPTIONS/SET_LOADING_STATUS',
  FETCH_CURRENT_PACKAGE_COMPLETE: '@YOLA_EDITOR/SUBSCRIPTIONS/FETCH_CURRENT_PACKAGE_COMPLETE',
};
